import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Fade } from '@mui/material';
import { useDispatch } from 'react-redux';
import { SetSplashOpen } from '../../store/features/splash';

export default function OpenScreen() {
  let time;
  const storageURL = process.env.REACT_APP_Stroage_URL;
  // const [open, setOpen] = useState(true);
  const dispatch = useDispatch();
  const { splash_open } = useSelector(store => store.splash)

  // const yetaiData = useSelector((store) => store.yetai.filterData);


  const closeHandler = () => {
    dispatch(SetSplashOpen(false));
    clearInterval(time)
  }
  const [text, setText] = useState('4s后关闭');
  const thumb = useSelector((store) => {
    let arr = store.splash.data;
    if (arr&&arr.length>0) {
      let target = arr.find(e => {
        return e.name.substr(0, 2) == '开屏'
      });
      if(target)
      {
        return target.thumb;
      }
      else{
        return null
      }
      
    }
    return null

  });

  useEffect(() => {
    let t = 4;
    time = setInterval(() => {
      t--;
      setText(t + 's后关闭')
      if (t == 0) {
        closeHandler();
      }
    }, 1000);

    return () => clearInterval(time);
  }, []);

  return (
    <Fade in={splash_open}>
      <Box sx={{ position: 'absolute', left: 0, top: 0, zIndex: 999999 }}>
        <Button variant='outlined' onClick={closeHandler} color='mblack' style={{ position: 'absolute', top: '1rem', right: '1rem' }}>{text}</Button>
        {thumb && <img style={{ width: '100vw', height: '100vh', objectFit: 'cover' }} src={storageURL + thumb}></img>
        }
      </Box>
    </Fade>
  );
}